module.exports = __webpack_public_path__ + "img/emptyDetail.1641520899224.png";